import { useState, useEffect } from "react";
import {
  Box, Paper, Typography, Button, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Dialog, DialogTitle,
  DialogContent, DialogActions, TextField, Grid, Alert, Snackbar,
  IconButton, Tooltip, Chip, FormControl, InputLabel, Select, MenuItem,
  InputAdornment, Divider
} from "@mui/material";
import {
  Add, Edit, Delete, Search, Refresh, Person, Phone, Email,
  CheckCircle, Cancel, AccountBalance, Visibility
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const PROVINCIAS_ECUADOR = [
  "AZUAY","BOLÍVAR","CAÑAR","CARCHI","CHIMBORAZO","COTOPAXI",
  "EL ORO","ESMERALDAS","GALÁPAGOS","GUAYAS","IMBABURA","LOJA",
  "LOS RÍOS","MANABÍ","MORONA SANTIAGO","NAPO","ORELLANA",
  "PASTAZA","PICHINCHA","SANTA ELENA","SANTO DOMINGO DE LOS TSÁCHILAS",
  "SUCUMBÍOS","TUNGURAHUA","ZAMORA CHINCHIPE"
];

const PAISES = [
  "ECUADOR", "COLOMBIA", "PERÚ", "ESTADOS UNIDOS", "ESPAÑA", "MÉXICO",
  "CHILE", "ARGENTINA", "BRASIL", "PANAMÁ", "COSTA RICA", "VENEZUELA",
  "BOLIVIA", "PARAGUAY", "URUGUAY", "REPÚBLICA DOMINICANA", "GUATEMALA",
  "HONDURAS", "EL SALVADOR", "NICARAGUA", "CUBA", "ALEMANIA", "FRANCIA",
  "ITALIA", "REINO UNIDO", "CHINA", "JAPÓN", "CANADÁ", "OTRO"
];

const CIUDADES_POR_PROVINCIA = {
  "AZUAY": ["CUENCA", "GUALACEO", "PAUTE", "SÍGSIG", "SANTA ISABEL", "GIRÓN", "NABÓN", "CHORDELEG"],
  "BOLÍVAR": ["GUARANDA", "SAN MIGUEL", "CHILLANES", "CHIMBO", "ECHEANDÍA", "CALUMA", "LAS NAVES"],
  "CAÑAR": ["AZOGUES", "CAÑAR", "LA TRONCAL", "EL TAMBO", "BIBLIÁN", "DÉLEG", "SUSCAL"],
  "CARCHI": ["TULCÁN", "SAN GABRIEL", "EL ÁNGEL", "MIRA", "BOLÍVAR", "HUACA"],
  "CHIMBORAZO": ["RIOBAMBA", "ALAUSÍ", "COLTA", "GUANO", "CHAMBO", "CHUNCHI", "GUAMOTE", "PALLATANGA", "PENIPE", "CUMANDÁ"],
  "COTOPAXI": ["LATACUNGA", "SALCEDO", "SAQUISILÍ", "PUJILÍ", "LA MANÁ", "PANGUA", "SIGCHOS"],
  "EL ORO": ["MACHALA", "PASAJE", "SANTA ROSA", "HUAQUILLAS", "EL GUABO", "ARENILLAS", "PIÑAS", "PORTOVELO", "ZARUMA", "BALSAS"],
  "ESMERALDAS": ["ESMERALDAS", "ATACAMES", "QUININDÉ", "SAN LORENZO", "MUISNE", "ELOY ALFARO", "RÍO VERDE"],
  "GALÁPAGOS": ["PUERTO BAQUERIZO MORENO", "PUERTO AYORA", "PUERTO VILLAMIL"],
  "GUAYAS": ["GUAYAQUIL", "DURÁN", "SAMBORONDÓN", "DAULE", "MILAGRO", "NARANJAL", "EL TRIUNFO", "NARANJITO", "PLAYAS", "BALAO", "YAGUACHI", "NOBOL", "SALITRE"],
  "IMBABURA": ["IBARRA", "OTAVALO", "COTACACHI", "ANTONIO ANTE", "PIMAMPIRO", "URCUQUÍ"],
  "LOJA": ["LOJA", "CATAMAYO", "MACARÁ", "CARIAMANGA", "SARAGURO", "CELICA", "GONZANAMÁ", "ZAPOTILLO"],
  "LOS RÍOS": ["BABAHOYO", "QUEVEDO", "VENTANAS", "VINCES", "BUENA FE", "VALENCIA", "MOCACHE", "PALENQUE", "PUEBLO VIEJO", "URDANETA"],
  "MANABÍ": ["PORTOVIEJO", "MANTA", "CHONE", "JIPIJAPA", "EL CARMEN", "PEDERNALES", "MONTECRISTI", "BAHÍA DE CARÁQUEZ", "TOSAGUA", "CALCETA"],
  "MORONA SANTIAGO": ["MACAS", "GUALAQUIZA", "SUCÚA", "LIMÓN INDANZA", "PALORA", "SANTIAGO"],
  "NAPO": ["TENA", "ARCHIDONA", "EL CHACO", "QUIJOS", "CARLOS JULIO AROSEMENA TOLA"],
  "ORELLANA": ["FRANCISCO DE ORELLANA (COCA)", "JOYA DE LOS SACHAS", "LORETO", "AGUARICO"],
  "PASTAZA": ["PUYO", "MERA", "SANTA CLARA", "ARAJUNO"],
  "PICHINCHA": ["QUITO", "CAYAMBE", "MEJÍA", "PEDRO MONCAYO", "PEDRO VICENTE MALDONADO", "PUERTO QUITO", "RUMIÑAHUI", "SAN MIGUEL DE LOS BANCOS"],
  "SANTA ELENA": ["SANTA ELENA", "LA LIBERTAD", "SALINAS"],
  "SANTO DOMINGO DE LOS TSÁCHILAS": ["SANTO DOMINGO", "LA CONCORDIA"],
  "SUCUMBÍOS": ["NUEVA LOJA (LAGO AGRIO)", "SHUSHUFINDI", "CASCALES", "GONZALO PIZARRO", "CUYABENO", "PUTUMAYO", "SUCUMBÍOS"],
  "TUNGURAHUA": ["AMBATO", "BAÑOS", "PELILEO", "PÍLLARO", "PATATE", "QUERO", "CEVALLOS", "MOCHA", "TISALEO"],
  "ZAMORA CHINCHIPE": ["ZAMORA", "YANTZAZA", "NANGARITZA", "CENTINELA DEL CÓNDOR", "EL PANGUI", "CHINCHIPE", "PALANDA"]
};

const REGIMENES = [
  "GENERAL", "GRAN CONTRIBUYENTE", "CONTRIBUYENTE ESPECIAL",
  "RIMPE EMPRENDEDOR", "RIMPE POPULAR"
];

const emptyForm = {
  razon_social: "", nombre_comercial: "", identificacion: "",
  emails: [], nombre_contacto: "",
  telefono_celular: "", telefono_convencional: "",
  direccion_1: "", direccion_2: "",
  pais: "ECUADOR", provincia_estado: "", ciudad: "", tipo_cliente: "NACIONAL",
  regimen: "GENERAL", tipo_persona: "NATURAL", obligado_contabilidad: "NO",
  limite_credito: 0, plazo_credito_dias: 0, descuento_porcentaje: 0,
  activo: true,
};

export default function Clientes() {
  const navigate = useNavigate();
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editando, setEditando] = useState(false);
  const [clienteSel, setClienteSel] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [busqueda, setBusqueda] = useState("");
  const [filtroActivo, setFiltroActivo] = useState("todos");
  const [formData, setFormData] = useState({ ...emptyForm });
  const [emailInput, setEmailInput] = useState("");
  const [verCliente, setVerCliente] = useState(null);
  const [pagina, setPagina] = useState(0);
  const POR_PAGINA = 20;

  const getAuthHeaders = () => {
    const token = localStorage.getItem("token");
    return { Authorization: `Bearer ${token}` };
  };

  useEffect(() => { cargarClientes(); }, [busqueda, filtroActivo]);

  const cargarClientes = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (busqueda) params.append("busqueda", busqueda);
      if (filtroActivo !== "todos") params.append("activo", filtroActivo === "activos");
      const res = await axios.get(`${API_URL}/api/clientes?${params}`, { headers: getAuthHeaders() });
      setClientes(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      setClientes([]);
      showSnackbar("Error al cargar clientes", "error");
    } finally { setLoading(false); }
  };

  const handleInput = (campo, valor) => {
    // Forzar mayúsculas solo en campos de texto específicos (no emails)
    const camposUppercase = ["razon_social", "nombre_comercial", "nombre_contacto", "direccion_1", "direccion_2"];
    const valorFinal = camposUppercase.includes(campo) && typeof valor === "string" ? valor.toUpperCase() : valor;
    setFormData(prev => ({ ...prev, [campo]: valorFinal }));
  };

  const agregarEmail = () => {
    if (!emailInput || !emailInput.includes("@")) return;
    setFormData(prev => ({ ...prev, emails: [...(prev.emails || []), emailInput] }));
    setEmailInput("");
  };

  const eliminarEmail = (idx) => {
    setFormData(prev => ({ ...prev, emails: prev.emails.filter((_, i) => i !== idx) }));
  };

  const abrirDialogo = (cliente = null) => {
    if (cliente) {
      setEditando(true);
      setClienteSel(cliente);
      setFormData({ ...emptyForm, ...cliente, emails: cliente.emails || [] });
    } else {
      setEditando(false);
      setClienteSel(null);
      setFormData({ ...emptyForm });
    }
    setEmailInput("");
    setDialogOpen(true);
  };

  const cerrarDialogo = () => { setDialogOpen(false); setEditando(false); setClienteSel(null); };

  const guardarCliente = async () => {
    if (!formData.identificacion || !formData.razon_social) {
      return showSnackbar("Identificación y Razón Social son requeridos", "error");
    }
    try {
      const url = editando ? `${API_URL}/api/clientes/${clienteSel.id}` : `${API_URL}/api/clientes`;
      const method = editando ? "put" : "post";
      await axios[method](url, formData, { headers: getAuthHeaders() });
      showSnackbar(editando ? "Cliente actualizado" : "Cliente creado", "success");
      cerrarDialogo();
      cargarClientes();
    } catch (error) {
      showSnackbar(error.response?.data?.error || "Error al guardar cliente", "error");
    }
  };

  const eliminarCliente = async (cliente) => {
    if (!window.confirm(`¿Desactivar cliente ${cliente.razon_social || cliente.nombre}?`)) return;
    try {
      await axios.delete(`${API_URL}/api/clientes/${cliente.id}`, { headers: getAuthHeaders() });
      showSnackbar("Cliente desactivado", "success");
      cargarClientes();
    } catch (error) {
      showSnackbar(error.response?.data?.error || "Error al desactivar", "error");
    }
  };

  const showSnackbar = (message, severity) => setSnackbar({ open: true, message, severity });

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3 }}>
        {/* Header */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Person />
            <Typography variant="h5" fontWeight={700}>Clientes</Typography>
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button variant="outlined" startIcon={<Refresh />} onClick={cargarClientes}>Actualizar</Button>
            <Button variant="contained" startIcon={<Add />} onClick={() => abrirDialogo()}>Nuevo Cliente</Button>
          </Box>
        </Box>

        {/* Filtros */}
        <Box sx={{ mb: 3 }}>
          <TextField fullWidth size="small"
            placeholder="Buscar por identificación, razón social, email..."
            value={busqueda} onChange={(e) => { setBusqueda(e.target.value); setPagina(0); }}
            InputProps={{ startAdornment: <Search sx={{ mr: 1, color: "text.secondary" }} /> }}
          />
        </Box>

        {/* Tabla */}
        {loading ? <Typography>Cargando...</Typography> : clientes.length === 0 ? (
          <Alert severity="info">No hay clientes registrados.</Alert>
        ) : (
          <>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                    <TableCell><strong>Identificación</strong></TableCell>
                    <TableCell><strong>Razón Social</strong></TableCell>
                    <TableCell><strong>Contacto</strong></TableCell>
                    <TableCell><strong>Referencia / Contacto</strong></TableCell>
                    <TableCell align="center"><strong>Acciones</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {clientes.slice(pagina * POR_PAGINA, (pagina + 1) * POR_PAGINA).map((c) => (
                  <TableRow key={c.id} hover>
                    <TableCell>
                      <Typography variant="body2" fontFamily="monospace">{c.identificacion}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" fontWeight={600}>{c.razon_social || c.nombre}</Typography>
                      {c.nombre_comercial && <Typography variant="caption" color="text.secondary">{c.nombre_comercial}</Typography>}
                    </TableCell>
                    <TableCell>
                      {(c.telefono_celular || c.telefono) && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                          <Phone sx={{ fontSize: 14 }} />
                          <Typography variant="caption">{c.telefono_celular || c.telefono}</Typography>
                        </Box>
                      )}
                      {(c.emails?.length > 0 || c.email) && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                          <Email sx={{ fontSize: 14 }} />
                          <Typography variant="caption">{c.emails?.[0] || c.email}</Typography>
                        </Box>
                      )}
                    </TableCell>
                    <TableCell>
                      {c.nombre_contacto && (
                        <Typography variant="caption" display="block" fontWeight={600}>{c.nombre_contacto}</Typography>
                      )}
                      {c.telefono_contacto && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                          <Phone sx={{ fontSize: 12 }} />
                          <Typography variant="caption">{c.telefono_contacto}</Typography>
                        </Box>
                      )}
                      {c.email_contacto && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                          <Email sx={{ fontSize: 12 }} />
                          <Typography variant="caption">{c.email_contacto}</Typography>
                        </Box>
                      )}
                      {!c.nombre_contacto && !c.telefono_contacto && !c.email_contacto && (
                        <Typography variant="caption" color="text.secondary">—</Typography>
                      )}
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip title="Ver detalle">
                        <IconButton size="small" color="default" onClick={() => setVerCliente(c)}>
                          <Visibility />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Estado de Cuenta">
                        <IconButton size="small" color="info" onClick={() => navigate(`/cuentas-cobrar/estado-cuenta/${c.id}`)}>
                          <AccountBalance />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Editar"><IconButton size="small" onClick={() => abrirDialogo(c)}><Edit /></IconButton></Tooltip>
                      {c.activo && <Tooltip title="Desactivar"><IconButton size="small" color="error" onClick={() => eliminarCliente(c)}><Delete /></IconButton></Tooltip>}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
              </Table>
            </TableContainer>
            {/* Paginación */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2, px: 1 }}>
              <Typography variant="body2" color="text.secondary">
                Mostrando {Math.min(pagina * POR_PAGINA + 1, clientes.length)}–{Math.min((pagina + 1) * POR_PAGINA, clientes.length)} de {clientes.length}
              </Typography>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button variant="outlined" size="small" disabled={pagina === 0}
                  onClick={() => setPagina(pagina - 1)}>← Anterior</Button>
                <Button variant="outlined" size="small" disabled={(pagina + 1) * POR_PAGINA >= clientes.length}
                  onClick={() => setPagina(pagina + 1)}>Siguiente →</Button>
              </Box>
            </Box>
          </>
        )}
      </Paper>

      {/* Dialog Crear/Editar */}
      <Dialog open={dialogOpen} onClose={cerrarDialogo} fullWidth
        PaperProps={{ sx: { borderRadius: 3, maxWidth: "900px", width: "95vw" } }}>
        <DialogTitle sx={{ pb: 1, fontWeight: 700, fontSize: 20 }}>
          {editando ? "✏️ Editar Cliente" : "➕ Nuevo Cliente"}
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ pt: 3 }}>
          {/* Identificación */}
          <Typography variant="subtitle1" fontWeight={700} color="primary" sx={{ mb: 2 }}>
            Identificación
          </Typography>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <TextField fullWidth required label="RUC / Cédula" value={formData.identificacion}
                onChange={(e) => handleInput("identificacion", e.target.value.replace(/\D/g, ""))}
                inputProps={{ maxLength: 13, style: { textTransform: "uppercase", fontSize: 16 } }} helperText="10 o 13 dígitos" disabled={editando} />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 5 }}>
              <TextField fullWidth required label="Razón Social / Nombres" value={formData.razon_social}
                onChange={(e) => handleInput("razon_social", e.target.value)}
                inputProps={{ style: { textTransform: "uppercase", fontSize: 16 } }} />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <TextField fullWidth label="Nombre Comercial" value={formData.nombre_comercial}
                onChange={(e) => handleInput("nombre_comercial", e.target.value)}
                inputProps={{ style: { textTransform: "uppercase", fontSize: 16 } }} />
            </Grid>
          </Grid>

          {/* Contacto */}
          <Typography variant="subtitle1" fontWeight={700} color="primary" sx={{ mb: 2 }}>
            Contacto
          </Typography>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid size={{ xs: 12, md: 4 }}>
              <TextField fullWidth label="Email" value={emailInput}
                onChange={(e) => setEmailInput(e.target.value)}
                onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); agregarEmail(); } }}
                placeholder="correo@ejemplo.com"
                inputProps={{ style: { fontSize: 16 } }} />
            </Grid>
            <Grid size={{ xs: 12, md: 2 }}>
              <Button variant="outlined" onClick={agregarEmail} fullWidth sx={{ height: 56 }}>+ Email</Button>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField fullWidth label="Teléfono Celular" value={formData.telefono_celular}
                onChange={(e) => handleInput("telefono_celular", e.target.value)} placeholder="0999999999"
                inputProps={{ style: { fontSize: 16 } }} />
            </Grid>
            {formData.emails?.length > 0 && (
              <Grid size={12}>
                <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
                  {formData.emails.map((email, i) => (
                    <Chip key={i} label={email} onDelete={() => eliminarEmail(i)} size="small" color="primary" variant="outlined" />
                  ))}
                </Box>
              </Grid>
            )}
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField fullWidth label="Teléfono Convencional" value={formData.telefono_convencional}
                onChange={(e) => handleInput("telefono_convencional", e.target.value)} placeholder="022999999"
                inputProps={{ style: { fontSize: 16 } }} />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField fullWidth label="Dirección" value={formData.direccion_1}
                onChange={(e) => handleInput("direccion_1", e.target.value)} placeholder="Calle principal, numeración, sector"
                inputProps={{ style: { textTransform: "uppercase", fontSize: 16 } }} />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <TextField fullWidth label="Nombre de Contacto" value={formData.nombre_contacto}
                onChange={(e) => handleInput("nombre_contacto", e.target.value)}
                inputProps={{ style: { textTransform: "uppercase", fontSize: 16 } }}
                placeholder="Persona de referencia" />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <TextField fullWidth label="Teléfono de Contacto" value={formData.telefono_contacto || ""}
                onChange={(e) => handleInput("telefono_contacto", e.target.value)}
                inputProps={{ style: { fontSize: 16 } }}
                placeholder="Teléfono del contacto" />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <TextField fullWidth label="Correo de Contacto" value={formData.email_contacto || ""}
                onChange={(e) => handleInput("email_contacto", e.target.value)}
                inputProps={{ style: { fontSize: 16 } }}
                placeholder="Email del contacto" />
            </Grid>
            <Grid size={12}>
              <TextField fullWidth label="Notas / Observaciones" value={formData.notas || ""}
                onChange={(e) => handleInput("notas", e.target.value)}
                inputProps={{ style: { fontSize: 16 } }}
                placeholder="Información adicional del cliente"
                multiline rows={2} />
            </Grid>
          </Grid>

          {/* Ubicación */}
          <Typography variant="subtitle1" fontWeight={700} color="primary" sx={{ mb: 2 }}>
            Ubicación
          </Typography>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <FormControl fullWidth>
                <InputLabel>País</InputLabel>
                <Select value={formData.pais} label="País"
                  onChange={(e) => {
                    const val = e.target.value;
                    handleInput("pais", val);
                    handleInput("tipo_cliente", val === "ECUADOR" ? "NACIONAL" : "EXTRANJERO");
                    if (val !== "ECUADOR") { handleInput("provincia_estado", ""); handleInput("ciudad", ""); }
                  }}>
                  {PAISES.map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}
                </Select>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              {formData.pais === "ECUADOR" ? (
                <FormControl fullWidth>
                  <InputLabel>Provincia</InputLabel>
                  <Select value={formData.provincia_estado} label="Provincia"
                    onChange={(e) => { handleInput("provincia_estado", e.target.value); handleInput("ciudad", ""); }}>
                    <MenuItem value="">— Seleccionar —</MenuItem>
                    {PROVINCIAS_ECUADOR.map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}
                  </Select>
                </FormControl>
              ) : (
                <TextField fullWidth label="Estado / Provincia" value={formData.provincia_estado}
                  onChange={(e) => handleInput("provincia_estado", e.target.value)}
                  inputProps={{ style: { textTransform: "uppercase", fontSize: 16 } }} />
              )}
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              {formData.pais === "ECUADOR" && formData.provincia_estado ? (
                <FormControl fullWidth>
                  <InputLabel>Ciudad</InputLabel>
                  <Select value={formData.ciudad || ""} label="Ciudad"
                    onChange={(e) => handleInput("ciudad", e.target.value)}>
                    <MenuItem value="">— Seleccionar —</MenuItem>
                    {(CIUDADES_POR_PROVINCIA[formData.provincia_estado] || []).map(c => (
                      <MenuItem key={c} value={c}>{c}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : (
                <TextField fullWidth label="Ciudad" value={formData.ciudad || ""}
                  onChange={(e) => handleInput("ciudad", e.target.value)}
                  inputProps={{ style: { textTransform: "uppercase", fontSize: 16 } }} />
              )}
            </Grid>
          </Grid>

          {/* Configuración Fiscal */}
          <Typography variant="subtitle1" fontWeight={700} color="primary" sx={{ mb: 2 }}>
            Configuración Fiscal
          </Typography>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <FormControl fullWidth>
                <InputLabel>Régimen</InputLabel>
                <Select value={formData.regimen} label="Régimen"
                  onChange={(e) => handleInput("regimen", e.target.value)}>
                  {REGIMENES.map(r => <MenuItem key={r} value={r}>{r}</MenuItem>)}
                </Select>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <FormControl fullWidth>
                <InputLabel>Tipo de Persona</InputLabel>
                <Select value={formData.tipo_persona} label="Tipo de Persona"
                  onChange={(e) => handleInput("tipo_persona", e.target.value)}>
                  <MenuItem value="NATURAL">Natural</MenuItem>
                  <MenuItem value="JURIDICA">Jurídica</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <FormControl fullWidth>
                <InputLabel>Obligado a Contabilidad</InputLabel>
                <Select value={formData.obligado_contabilidad} label="Obligado a Contabilidad"
                  onChange={(e) => handleInput("obligado_contabilidad", e.target.value)}>
                  <MenuItem value="SI">Sí</MenuItem>
                  <MenuItem value="NO">No</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {/* Crédito */}
          <Typography variant="subtitle1" fontWeight={700} color="primary" sx={{ mb: 2 }}>
            Condiciones de Crédito
          </Typography>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <FormControl fullWidth>
                <InputLabel>Plazo de Crédito</InputLabel>
                <Select value={formData.plazo_credito_dias} label="Plazo de Crédito"
                  onChange={(e) => {
                    const val = parseInt(e.target.value) || 0;
                    handleInput("plazo_credito_dias", val);
                    if (val === 0) handleInput("limite_credito", 0);
                  }}>
                  <MenuItem value={0}>Sin crédito</MenuItem>
                  <MenuItem value={30}>30 días</MenuItem>
                  <MenuItem value={60}>60 días</MenuItem>
                  <MenuItem value={90}>90 días</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <TextField fullWidth label="Cupo Máximo" type="number"
                value={formData.limite_credito}
                onChange={(e) => handleInput("limite_credito", parseFloat(e.target.value) || 0)}
                InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                inputProps={{ min: 0, step: 0.01, style: { fontSize: 16 } }}
                disabled={formData.plazo_credito_dias === 0} />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <TextField fullWidth label="Descuento %" type="number"
                value={formData.descuento_porcentaje}
                onChange={(e) => handleInput("descuento_porcentaje", parseFloat(e.target.value) || 0)}
                inputProps={{ min: 0, max: 100, step: 0.01, style: { fontSize: 16 } }} />
            </Grid>
          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions sx={{ p: 2.5 }}>
          <Button onClick={cerrarDialogo} color="inherit">Cancelar</Button>
          <Button onClick={guardarCliente} variant="contained" size="large">
            {editando ? "Actualizar" : "Crear"} Cliente
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Ver Detalle */}
      <Dialog open={!!verCliente} onClose={() => setVerCliente(null)} maxWidth="md" fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}>
        {verCliente && (
          <>
            <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>
              👁️ {verCliente.razon_social || verCliente.nombre}
            </DialogTitle>
            <Divider />
            <DialogContent sx={{ pt: 2 }}>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 6 }}>
                  <Typography variant="subtitle2" color="primary" gutterBottom>Identificación</Typography>
                  <Box sx={{ pl: 1, mb: 2 }}>
                    <Typography variant="body2"><strong>RUC/CI:</strong> {verCliente.identificacion}</Typography>
                    <Typography variant="body2"><strong>Razón Social:</strong> {verCliente.razon_social || "—"}</Typography>
                    <Typography variant="body2"><strong>Nombre Comercial:</strong> {verCliente.nombre_comercial || "—"}</Typography>
                  </Box>

                  <Typography variant="subtitle2" color="primary" gutterBottom>Contacto</Typography>
                  <Box sx={{ pl: 1, mb: 2 }}>
                    <Typography variant="body2"><strong>Emails:</strong> {(verCliente.emails || []).join(", ") || verCliente.email || "—"}</Typography>
                    <Typography variant="body2"><strong>Celular:</strong> {verCliente.telefono_celular || "—"}</Typography>
                    <Typography variant="body2"><strong>Convencional:</strong> {verCliente.telefono_convencional || "—"}</Typography>
                    <Typography variant="body2"><strong>Dirección:</strong> {verCliente.direccion_1 || verCliente.direccion || "—"}</Typography>
                  </Box>

                  <Typography variant="subtitle2" color="primary" gutterBottom>Referencia / Contacto</Typography>
                  <Box sx={{ pl: 1 }}>
                    <Typography variant="body2"><strong>Nombre:</strong> {verCliente.nombre_contacto || "—"}</Typography>
                    <Typography variant="body2"><strong>Teléfono:</strong> {verCliente.telefono_contacto || "—"}</Typography>
                    <Typography variant="body2"><strong>Email:</strong> {verCliente.email_contacto || "—"}</Typography>
                    <Typography variant="body2"><strong>Notas:</strong> {verCliente.notas || "—"}</Typography>
                  </Box>
                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>
                  <Typography variant="subtitle2" color="primary" gutterBottom>Ubicación</Typography>
                  <Box sx={{ pl: 1, mb: 2 }}>
                    <Typography variant="body2"><strong>País:</strong> {verCliente.pais || "ECUADOR"}</Typography>
                    <Typography variant="body2"><strong>Provincia:</strong> {verCliente.provincia_estado || "—"}</Typography>
                    <Typography variant="body2"><strong>Ciudad:</strong> {verCliente.ciudad || "—"}</Typography>
                    <Typography variant="body2"><strong>Tipo:</strong> {verCliente.tipo_cliente || "NACIONAL"}</Typography>
                  </Box>

                  <Typography variant="subtitle2" color="primary" gutterBottom>Configuración Fiscal</Typography>
                  <Box sx={{ pl: 1, mb: 2 }}>
                    <Typography variant="body2"><strong>Régimen:</strong> {verCliente.regimen || "GENERAL"}</Typography>
                    <Typography variant="body2"><strong>Tipo Persona:</strong> {verCliente.tipo_persona || "NATURAL"}</Typography>
                    <Typography variant="body2"><strong>Obligado Contabilidad:</strong> {verCliente.obligado_contabilidad || "NO"}</Typography>
                  </Box>

                  <Typography variant="subtitle2" color="primary" gutterBottom>Crédito</Typography>
                  <Box sx={{ pl: 1 }}>
                    <Typography variant="body2"><strong>Plazo:</strong> {verCliente.plazo_credito_dias ? `${verCliente.plazo_credito_dias} días` : "Sin crédito"}</Typography>
                    <Typography variant="body2"><strong>Cupo Máximo:</strong> ${parseFloat(verCliente.limite_credito || 0).toFixed(2)}</Typography>
                    <Typography variant="body2"><strong>Descuento:</strong> {verCliente.descuento_porcentaje || 0}%</Typography>
                  </Box>
                </Grid>
              </Grid>
            </DialogContent>
            <Divider />
            <DialogActions sx={{ p: 2 }}>
              <Button onClick={() => { setVerCliente(null); abrirDialogo(verCliente); }} startIcon={<Edit />}>Editar</Button>
              <Button onClick={() => setVerCliente(null)} variant="contained">Cerrar</Button>
            </DialogActions>
          </>
        )}
      </Dialog>

      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
}
